import React, { useState, useEffect } from "react";
import config from "config/config.js";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import PropTypes from "prop-types";
// import getAllImages from "api/images/getAllImages.js";

export default function RestaurantImages(props) {
  const restaurantImages = props.restaurantImages;
  return (
    <div style={{ width: "100%", float: "left", position: "relative" }}>
      <CarouselProvider
        naturalSlideWidth={33}
        naturalSlideHeight={33}
        totalSlides={restaurantImages.length}
        visibleSlides={3}
        infinite
        className={"desktop_images_carousel"}
        isPlaying
        interval={5000}
      >
        <Slider>
          {restaurantImages.map((el, i) => (
            <Slide index={i - 1} key={`ov_image_${i + 1}`}>
              <img
                alt=""
                title=""
                src={el.url}
                style={{ width: "100%", height: "auto" }}
              />
            </Slide>
          ))}
        </Slider>
        <ButtonBack className="restaurant_carousel_arrow prev">
          <i className="icon icon-previous-page-24" />
        </ButtonBack>
        <ButtonNext className="restaurant_carousel_arrow next">
          <i className="icon icon-next-page24" />
        </ButtonNext>
      </CarouselProvider>
      <CarouselProvider
        naturalSlideWidth={33}
        naturalSlideHeight={33}
        totalSlides={restaurantImages.length}
        visibleSlides={1}
        infinite
        className={"mobile_images_carousel"}
        isPlaying
        interval={5000}
      >
        <Slider>
          {restaurantImages.map((el, i) => (
            <Slide index={i - 1} key={`ov_image_${i + 1}`}>
              <img
                alt=""
                title=""
                src={el.url}
                style={{ width: "100%", height: "auto" }}
              />
            </Slide>
          ))}
        </Slider>
        <ButtonBack className="restaurant_carousel_arrow prev">
          <i className="icon icon-previous-page-24" />
        </ButtonBack>
        <ButtonNext className="restaurant_carousel_arrow next">
          <i className="icon icon-next-page24" />
        </ButtonNext>
      </CarouselProvider>
    </div>
  );
}

RestaurantImages.propTypes = {
  restaurantImages: PropTypes.array.isRequired
};
